import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
@Injectable()
export class LoaderService {
    isLoading = new Subject<boolean>();
    message = new BehaviorSubject<string>('');
    show(message?: string) {
        if (message) {
            this.message.next(message);
        }
        this.isLoading.next(true);
    }
    hide() {
        this.isLoading.next(false);
        this.message.next('');
    }
}